import axios from "axios";

const api = axios.create({
  baseURL: "https://zenqb.com",
  //baseURL: "http://localhost:5000",
  //baseURL: "http://127.0.0.1:5000",
});

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("token") ||
    JSON.parse(localStorage.getItem("user"))?.access_token;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);
export default api;